module.exports = __webpack_public_path__ + "static/img/Inca_logo_PNG.d9b2b1c9.png";